var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetzanschlussmonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 303,
    viewBox: "0 0 457 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Netzanschlussmonitor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.809 302.099L0.227051 165.972L0.261719 146.76L33.2676 134.743L238.639 252.237L253.935 287.887L236.809 302.099Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.815 302.89L0.227051 166.293V163.755L236.815 300.496V302.89Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.773 176.144L236.815 302.891L236.81 284.1L236.815 243.746L428.691 146.518L456.757 156.553L456.773 176.144Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.227051 146.811L236.809 284.099L456.757 156.552L220.03 31.7188L0.227051 146.811Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Karte"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M117.055 113.632L121.12 101.663L142.364 94.1572L141.527 88.7139L146.97 87.5973L150.878 91.3657L169.72 93.3197L180.747 95.2738L177.816 93.3197L196.797 82.8519L192.331 77.4086L193.866 73.9193L224.153 77.4086L227.922 79.9209L219.268 82.8519L223.176 84.2476L222.339 86.3412H218.012L219.268 88.7139L225.549 89.9701L224.153 92.3428L230.993 95.2738V97.6465L244.112 101.973L241.6 104.486L230.993 101.973L222.339 106.16L235.319 116.768L244.112 112.72L262.117 109.789L265.885 113.837L259.046 116.768H248.997L246.904 120.676L259.046 122.769L283.751 118.582L286.542 123.607L270.393 130.725L268.893 138.262L284.728 145.241L282.355 147.474L270.926 150.823L283.04 157.523L294.106 147.474L297.719 148.73L309.432 139.099H314.038L318.225 146.497L337.067 150.823L366.238 148.73L364.144 155.011L383.266 159.198L382.568 165.897H373.914L372.239 176.729L357.445 182.506L346.139 176.446L299.713 173.704L302.455 176.729L300.659 179.349L289.361 179.093L280.994 178.62L268.893 176.446L270.926 172.617L277.62 169.639L283.358 170.584L283.04 171.896L294.106 174.832L297.719 171.896L278.975 168.509L277.62 164.67H267.683L263.619 174.832L257.069 173.251V177.316L270.393 187.027L281.233 179.349L297.719 184.769L302.687 195.157L290.944 196.512L288.008 212.32L297.719 217.288L288.008 224.063L294.106 225.644L285.298 231.516L254.811 233.322L213.258 224.063L146.187 198.319V191.318L152.736 184.769L165.834 180.93H163.124L136.25 179.349L128.572 171.896L124.281 166.928L140.767 171.896L146.187 169.638L124.281 164.67L133.766 156.766L124.281 147.733L128.572 140.28L133.766 142.087L138.508 138.474H136.25L140.767 135.764L138.508 132.15L146.187 128.537L133.766 124.472L138.508 121.536L117.055 113.632Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nadel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70",
    d: "M250.214 185.29C252.517 190.348 250.095 195.212 239.742 199.926C229.389 204.64 212.851 210.833 210.547 205.775C208.244 200.716 222.546 186.852 232.899 182.138C243.252 177.424 247.911 180.231 250.214 185.29Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549",
    d: "M211.806 152.629L216.432 152.629L219.137 156.405H209.64L211.806 152.629Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.82 207.627C215.766 207.627 228.05 177.106 228.05 168.396C228.05 159.685 220.989 152.624 212.278 152.624C203.567 152.624 196.506 159.685 196.506 168.396C196.506 177.106 209.873 207.627 212.82 207.627ZM214.03 172.838C217.38 172.838 220.096 170.122 220.096 166.772C220.096 163.422 217.38 160.706 214.03 160.706C210.68 160.706 207.964 163.422 207.964 166.772C207.964 170.122 210.68 172.838 214.03 172.838Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.87 207.67C215.816 207.67 232.029 177.106 232.029 168.396C232.029 159.685 224.968 152.624 216.257 152.624C207.547 152.624 200.485 159.685 200.485 168.396C200.485 177.106 209.923 207.67 212.87 207.67ZM216.257 173.595C219.608 173.595 222.324 170.879 222.324 167.529C222.324 164.179 219.608 161.463 216.257 161.463C212.907 161.463 210.191 164.179 210.191 167.529C210.191 170.879 212.907 173.595 216.257 173.595Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nadel4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70_2",
    d: "M395.908 151.008C398.211 156.066 395.789 160.93 385.436 165.644C375.083 170.358 358.544 176.551 356.241 171.493C353.938 166.434 368.24 152.57 378.593 147.856C388.946 143.142 393.604 145.949 395.908 151.008Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_2",
    d: "M357.5 118.347L362.126 118.347L364.831 122.123H355.334L357.5 118.347Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.513 173.345C361.46 173.345 373.744 142.824 373.744 134.114C373.744 125.403 366.682 118.342 357.972 118.342C349.261 118.342 342.2 125.403 342.2 134.114C342.2 142.824 355.567 173.345 358.513 173.345ZM359.724 138.556C363.074 138.556 365.79 135.84 365.79 132.49C365.79 129.14 363.074 126.424 359.724 126.424C356.374 126.424 353.658 129.14 353.658 132.49C353.658 135.84 356.374 138.556 359.724 138.556Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.563 173.388C361.51 173.388 377.723 142.824 377.723 134.114C377.723 125.403 370.662 118.342 361.951 118.342C353.241 118.342 346.179 125.403 346.179 134.114C346.179 142.824 355.617 173.388 358.563 173.388ZM361.951 139.313C365.302 139.313 368.017 136.597 368.017 133.247C368.017 129.897 365.302 127.181 361.951 127.181C358.601 127.181 355.885 129.897 355.885 133.247C355.885 136.597 358.601 139.313 361.951 139.313Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nadel3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70_3",
    d: "M244.13 87.1875C246.434 92.2461 244.012 97.11 233.659 101.824C223.306 106.538 206.767 112.731 204.464 107.673C202.161 102.614 216.463 88.7499 226.816 84.0361C237.169 79.3222 241.827 82.129 244.13 87.1875Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_3",
    d: "M205.722 54.5272L210.349 54.5272L213.054 58.3025H203.557L205.722 54.5272Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.736 109.525C209.682 109.525 221.966 79.0041 221.966 70.2934C221.966 61.5828 214.905 54.5214 206.194 54.5214C197.484 54.5214 190.422 61.5828 190.422 70.2934C190.422 79.0041 203.79 109.525 206.736 109.525ZM207.947 74.7361C211.297 74.7361 214.013 72.0202 214.013 68.67C214.013 65.3197 211.297 62.6038 207.947 62.6038C204.596 62.6038 201.881 65.3197 201.881 68.67C201.881 72.0202 204.596 74.7361 207.947 74.7361Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.786 109.568C209.733 109.568 225.946 79.0042 225.946 70.2936C225.946 61.5829 218.885 54.5215 210.174 54.5215C201.463 54.5215 194.402 61.5829 194.402 70.2936C194.402 79.0042 203.84 109.568 206.786 109.568ZM210.174 75.493C213.524 75.493 216.24 72.7771 216.24 69.4268C216.24 66.0766 213.524 63.3607 210.174 63.3607C206.824 63.3607 204.108 66.0766 204.108 69.4268C204.108 72.7771 206.824 75.493 210.174 75.493Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nadel2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70_4",
    d: "M275.674 132.36C277.977 137.418 275.556 142.282 265.203 146.996C254.85 151.71 238.311 157.903 236.008 152.845C233.705 147.786 248.007 133.922 258.36 129.208C268.713 124.494 273.371 127.301 275.674 132.36Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_4",
    d: "M237.266 99.6994L241.893 99.6993L244.598 103.475H235.101L237.266 99.6994Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.28 154.697C241.226 154.697 253.51 124.176 253.51 115.466C253.51 106.755 246.449 99.6935 237.738 99.6935C229.028 99.6935 221.966 106.755 221.966 115.466C221.966 124.176 235.334 154.697 238.28 154.697ZM239.491 119.908C242.841 119.908 245.557 117.192 245.557 113.842C245.557 110.492 242.841 107.776 239.491 107.776C236.14 107.776 233.424 110.492 233.424 113.842C233.424 117.192 236.14 119.908 239.491 119.908Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.33 154.74C241.276 154.74 257.49 124.176 257.49 115.466C257.49 106.755 250.428 99.6937 241.718 99.6937C233.007 99.6937 225.946 106.755 225.946 115.466C225.946 124.176 235.384 154.74 238.33 154.74ZM241.718 120.665C245.068 120.665 247.784 117.949 247.784 114.599C247.784 111.249 245.068 108.533 241.718 108.533C238.368 108.533 235.652 111.249 235.652 114.599C235.652 117.949 238.368 120.665 241.718 120.665Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B\xC3\xBCsche"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.5104 149.338C84.7003 152.251 84.7003 157.058 79.5104 160.097C73.6643 163.072 66.7479 163.072 60.9029 160.097C55.714 157.184 55.714 152.376 60.9029 149.338C66.7479 146.362 73.6643 146.362 79.5104 149.338Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.5968 121.994C76.2447 121.994 84.0655 130.155 84.0655 140.223C84.0655 150.29 76.2447 158.451 66.5968 158.451C56.9479 158.451 49.1282 150.29 49.1282 140.223C49.1282 130.155 56.9479 121.994 66.5968 121.994Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79.1273 147.945C71.3225 151.868 62.1199 151.868 54.3162 147.945C50.7671 145.919 49.1284 143.262 49.1284 140.603C48.8533 144.312 50.8548 147.817 54.1899 149.463C61.9936 153.387 71.1951 153.387 78.9999 149.463C81.8865 147.831 83.8174 144.912 84.1899 141.615C83.5338 144.376 81.6757 146.698 79.1273 147.945Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77.3517 136.678C70.5862 140.097 62.5985 140.097 55.833 136.678C53.566 135.616 51.9263 133.555 51.4019 131.108C51.0208 133.513 52.5418 136.037 55.833 137.944C62.5985 141.363 70.5862 141.363 77.3517 137.944C80.6419 136.044 82.0344 133.513 81.7818 131.108C81.2926 133.572 79.6422 135.646 77.3517 136.678Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.146 170.457C101.891 171.998 101.891 174.541 99.146 176.148C96.0538 177.722 92.3954 177.722 89.3038 176.148C86.5592 174.607 86.5592 172.064 89.3038 170.457C92.3954 168.883 96.0538 168.883 99.146 170.457Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M92.3155 155.994C97.4186 155.994 101.555 160.311 101.555 165.636C101.555 170.961 97.4186 175.277 92.3155 175.277C87.2118 175.277 83.0757 170.961 83.0757 165.636C83.0757 160.311 87.2118 155.994 92.3155 155.994Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M98.9433 169.721C94.8151 171.795 89.9475 171.795 85.8198 169.721C83.9425 168.649 83.0758 167.243 83.0758 165.837C82.9303 167.799 83.989 169.653 85.753 170.523C89.8807 172.599 94.7477 172.599 98.8759 170.523C100.403 169.66 101.424 168.116 101.621 166.372C101.274 167.833 100.291 169.061 98.9433 169.721Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M98.0042 163.761C94.4257 165.569 90.2007 165.569 86.6222 163.761C85.4231 163.199 84.5558 162.109 84.2784 160.815C84.0769 162.087 84.8813 163.422 86.6222 164.431C90.2007 166.239 94.4257 166.239 98.0042 164.431C99.7445 163.426 100.481 162.087 100.347 160.815C100.089 162.118 99.2157 163.215 98.0042 163.761Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M105.146 135.457C107.891 136.998 107.891 139.541 105.146 141.148C102.054 142.722 98.3954 142.722 95.3038 141.148C92.5592 139.607 92.5592 137.064 95.3038 135.457C98.3954 133.883 102.054 133.883 105.146 135.457Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M98.3155 120.994C103.419 120.994 107.555 125.311 107.555 130.636C107.555 135.961 103.419 140.277 98.3155 140.277C93.2118 140.277 89.0757 135.961 89.0757 130.636C89.0757 125.311 93.2118 120.994 98.3155 120.994Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M104.943 134.721C100.815 136.795 95.9475 136.795 91.8198 134.721C89.9425 133.649 89.0758 132.243 89.0758 130.837C88.9303 132.799 89.989 134.653 91.753 135.523C95.8807 137.599 100.748 137.599 104.876 135.523C106.403 134.66 107.424 133.116 107.621 131.372C107.274 132.833 106.291 134.061 104.943 134.721Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M104.004 128.761C100.426 130.569 96.2007 130.569 92.6222 128.761C91.4231 128.199 90.5558 127.109 90.2784 125.815C90.0769 127.087 90.8813 128.422 92.6222 129.431C96.2007 131.239 100.426 131.239 104.004 129.431C105.744 128.426 106.481 127.087 106.347 125.815C106.089 127.118 105.216 128.215 104.004 128.761Z",
    fill: "#D9D9D0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Masten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M317.639 95.3328C317.639 95.3328 243.371 86.3163 197.36 22.926",
    stroke: "#3C3839",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M151.629 115.103L171.893 126.803L192.157 115.103L171.893 103.403L151.629 115.103Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.464 58.8714L224.977 66.5748L211.465 67.0146L201.689 69.6114L210.517 74.8343L159.837 103.783L160.304 118.167L172.421 125.81L229.898 92.9158L239.989 97.7817L241.498 92.5501L244.344 84.6482L251.159 80.7485L250.713 66.2923L238.464 58.8714ZM241.498 82.9644L247.289 79.6545L240.512 75.2892L240.532 75.7778L244.754 78.276L240.722 80.5257L240.804 82.5533L241.498 82.9644ZM216.508 78.3787L213.196 76.4191L210.8 77.8019L213.945 79.8085L216.508 78.3787ZM211.465 81.1923L209.631 80.011L209.812 88.2593L215.935 84.6548L210.754 81.5892L211.465 81.1923ZM220.342 87.262L220.491 95.0335L227.099 91.2597L220.342 87.262ZM229.987 69.5391L236.032 73.1153L236.717 72.7236L229.94 68.3583L229.987 69.5391ZM177.924 119.396L177.601 111.341L184.378 115.707L177.924 119.396ZM187.538 105.723L187.861 113.778L194.315 110.089L187.538 105.723ZM184.525 92.9143L184.883 100.967L178.087 96.6307L184.525 92.9143ZM207.526 88.0362L207.168 79.9835L200.73 83.6999L207.526 88.0362ZM237.781 70.5133L237.423 62.4606L230.985 66.1769L237.781 70.5133ZM174.612 98.5746L174.97 106.627L168.174 102.291L174.612 98.5746ZM195.48 107.867L195.122 99.8145L188.484 103.682L195.48 107.867ZM207.709 92.5501L207.91 100.666L201.071 96.4173L207.709 92.5501ZM218.112 94.8533L217.912 86.7378L211.274 90.605L218.112 94.8533ZM185.308 105.436L185.665 113.489L178.753 109.166L185.308 105.436ZM210.054 92.7344L210.377 100.789L216.831 97.0997L210.054 92.7344ZM199.466 85.9215L199.789 93.9756L206.243 90.2868L199.466 85.9215ZM187.023 92.9625L187.205 101.123L193.8 97.3278L187.023 92.9625ZM177.586 106.627L177.263 98.5732L184.04 102.938L177.586 106.627ZM248.426 77.4114L241.613 73.1549L248.141 69.4964L248.426 77.4114ZM240.365 70.654L239.989 62.6928L246.78 67.0146L240.365 70.654ZM197.88 108.045L197.642 98.4155L198.74 97.7817L206.75 102.945L197.88 108.045ZM197.3 95.4297L197.051 85.8006L188.187 90.911L196.203 96.0648L197.3 95.4297Z",
    fill: "url(#paint0_linear_1528_778)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M158.396 108.279L171.905 100.479L185.414 108.279L171.905 116.078L158.396 108.279Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M158.396 108.279V116.078L171.905 123.878V116.078L158.396 108.279Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M171.905 123.878L185.414 116.078V108.279L171.905 116.078V123.878Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M171.905 89.8495V88.1144L182.409 94.2557V95.9144L171.905 89.8495Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M171.905 88.1143L173.407 87.2467L182.409 92.6859V94.2556L171.905 88.1143Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M170.403 101.344V58.4453L171.905 59.3129V102.211L170.403 101.344Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M173.407 101.344V58.4453L171.905 59.3129V102.211L173.407 101.344Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M171.905 76.4322V74.6971L182.409 80.7647V82.4962L171.905 76.4322Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M171.905 74.6973L173.407 73.8297L182.409 79.2689V80.8377L171.905 74.6973Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M171.905 89.8495V88.1144L161.4 94.2557V95.9144L171.905 89.8495Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M171.905 88.1143L170.402 87.2467L161.4 92.6859V94.2556L171.905 88.1143Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M171.905 76.4322V74.6971L161.4 80.8375V82.4962L171.905 76.4322Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M171.905 74.6973L170.402 73.8297L161.4 79.2689V80.8377L171.905 74.6973Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M158.396 108.279V65.3815L159.898 66.249V109.146L158.396 108.279Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M161.4 108.279V65.3815L159.898 66.249V109.146L161.4 108.279Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M170.403 115.21V72.313L171.905 73.1806V116.078L170.403 115.21Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M173.407 115.21L173.389 70.5832L171.886 71.4508L171.905 116.078L173.407 115.21Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M182.409 108.279V65.3815L183.911 66.249V109.146L182.409 108.279Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M185.414 108.279L185.393 63.6857L183.891 64.5532L183.912 109.146L185.414 108.279Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M171.905 45.4463V43.7111L182.409 49.7787V51.5102L171.905 45.4463Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M171.905 43.7111L173.407 42.8435L182.409 48.2818V49.8515L171.905 43.7111Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M171.905 59.3787V57.6436L182.409 63.7111V65.4436L171.905 59.3787Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M171.905 57.6433L173.407 56.7757L182.409 62.2149V63.7846L171.905 57.6433Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M159.898 96.7848V95.0496L170.403 101.191V102.85L159.898 96.7848Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M159.898 95.0495L161.4 94.1819L170.403 99.6211V101.191L159.898 95.0495Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M159.898 83.3675V81.6324L170.403 87.7737V89.4324L159.898 83.3675Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M159.898 81.6323L161.4 80.7647L170.403 86.2039V87.7736L159.898 81.6323Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M183.912 96.8576V95.1234L173.407 101.264V102.922L183.912 96.8576Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M183.912 95.1233L182.409 94.2557L173.407 99.694V101.264L183.912 95.1233Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M183.912 83.4403V81.7052L173.407 87.8465V89.5052L183.912 83.4403Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M183.912 81.7052L182.409 80.8376L173.407 86.2767V87.8465L183.912 81.7052Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M183.912 66.2731L183.89 64.5272L171.923 71.4507L171.922 73.1705L183.912 66.2731Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M185.414 63.6463L183.911 62.7787L170.421 70.5833L171.923 71.4508L185.414 63.6463Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M171.905 59.3435L171.87 57.5922L159.898 64.5183L159.897 66.2481L171.905 59.3435Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M173.389 56.713L171.886 55.8464L158.396 63.6509L159.898 64.5185L173.389 56.713Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M158.403 65.4424V49.7704L159.906 50.638V66.3099L158.403 65.4424Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M161.409 63.6659V49.7704L159.906 50.638V64.5334L161.409 63.6659Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M170.351 56.7354L170.355 42.8057L171.874 43.6841V57.6146L170.351 56.7354Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M173.377 56.748V42.8165L171.875 43.6841V57.6146L173.377 56.748Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M173.377 44.531V42.8148L159.906 50.6382V52.3328L173.377 44.531Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M173.376 42.8147L171.851 41.9346L158.403 49.7706L159.906 50.6381L173.376 42.8147Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M170.419 70.6136V56.7181L171.922 57.5857V71.4812L170.419 70.6136Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M173.424 70.6136V56.7181L171.922 57.5857V71.4812L173.424 70.6136Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M182.367 63.6831L182.371 49.7544L183.89 50.6319V64.5633L182.367 63.6831Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M185.392 63.6957V49.7643L183.89 50.6319V64.5633L185.392 63.6957Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M185.415 51.5084L185.392 49.7625L171.922 57.5859V59.2806L185.415 51.5084Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M185.392 49.7625L183.867 48.8823L170.419 56.7183L171.922 57.5859L185.392 49.7625Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M263.263 123.845C263.263 123.845 188.995 114.828 142.984 51.4379",
    stroke: "#3C3839",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M159.898 66.3137V64.5786L170.403 70.7199V72.3786L159.898 66.3137Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M159.898 64.5785L161.4 63.7109L170.403 69.1501V70.7198L159.898 64.5785Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M159.898 52.3813V50.6462L170.403 56.7866V58.4453L159.898 52.3813Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M159.898 50.6463L161.4 49.7787L170.403 55.2179V56.7867L159.898 50.6463Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M158.403 49.7642V35.8687L159.906 36.7363V50.6318L158.403 49.7642Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M161.409 49.7642V35.8687L159.906 36.7363V50.6318L161.409 49.7642Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M170.351 42.8335L170.355 28.9039L171.874 29.7822V43.7128L170.351 42.8335Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M173.377 42.8453V28.9148L171.875 29.7824V43.7129L173.377 42.8453Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M201.072 14.4647V12.7493L130.905 53.5358V55.2305L201.072 14.4647Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M173.376 28.9131L171.851 28.0329L158.403 35.8689L159.906 36.7365L173.376 28.9131Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M201.079 12.7331L199.554 11.8521L129.41 52.6547L130.912 53.5223L201.079 12.7331Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M171.875 31.5174V29.7822L182.379 35.8498V37.5823L171.875 31.5174Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M171.875 29.7824L173.377 28.9148L183.868 34.9806L182.379 35.9237L171.875 29.7824Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M201.178 14.382L201.157 12.636L173.316 15.0491V16.7437L201.178 14.382Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M201.156 12.6342L199.438 11.8709L171.812 14.1832L173.315 15.0499L201.156 12.6342Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M159.906 38.4715V36.7364L170.359 42.7878L168.985 43.5843L159.906 38.4715Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M159.906 36.7364L161.335 35.894L171.851 41.9822L170.46 42.8462L159.906 36.7364Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M158.345 35.9345V22.0391L159.847 22.9066V36.8021L158.345 35.9345Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M161.349 35.9345V22.0391L159.847 22.9066V36.8021L161.349 35.9345Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M170.292 29.0038L170.296 15.0751L171.815 15.9525V29.884L170.292 29.0038Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M173.318 29.0163V15.0849L171.815 15.9525V29.8839L173.318 29.0163Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M173.318 16.7992V15.0829L159.847 22.9063V24.601L173.318 16.7992Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M173.318 15.0832L171.792 14.203L158.345 22.039L159.847 22.9066L173.318 15.0832Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M181.005 26.2733V24.5381L191.56 30.648L190.26 31.3295L181.005 26.2733Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M181.005 24.5381L182.434 23.6957L192.95 29.784L191.56 30.648L181.005 24.5381Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M190.774 20.3991V18.6639L201.329 24.7738L200.331 25.7663L190.774 20.3991Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M190.774 18.6639L192.203 17.8215L202.719 23.9098L201.329 24.7738L190.774 18.6639Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M199.653 15.1785V13.4434L210.207 19.5532L210.173 21.3L199.653 15.1785Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M199.653 13.4433L201.082 12.601L211.598 18.6892L210.207 19.5532L199.653 13.4433Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M170.419 56.712V42.8165L171.922 43.6841V57.5796L170.419 56.712Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M173.424 56.712V42.8165L171.922 43.6841V57.5796L173.424 56.712Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M182.367 49.7812L182.371 35.8525L183.89 36.7299V50.6614L182.367 49.7812Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M185.392 49.794V35.8626L183.89 36.7302V50.6616L185.392 49.794Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M213.109 21.4421L213.088 19.6971L142.921 60.4836V62.1783L213.109 21.4421Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M213.087 19.6952L211.369 18.931L141.418 59.6168L142.92 60.4844L213.087 19.6952Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M213.11 21.4421L213.088 19.6971L185.248 22.1101V23.8048L213.11 21.4421Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M213.087 19.6952L211.598 18.6892L183.743 21.2434L185.246 22.1109L213.087 19.6952Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M171.875 17.8062V16.0711L182.379 22.1387V23.8702L171.875 17.8062Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M171.875 16.0712L173.377 15.2037L183.868 21.2695L182.379 22.2116L171.875 16.0712Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M170.36 42.8823V28.9868L171.863 29.8544V43.7499L170.36 42.8823Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M173.365 42.8823V28.9868L171.863 29.8544V43.7499L173.365 42.8823Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M182.308 35.9516L182.312 22.0228L183.831 22.9003V36.8317L182.308 35.9516Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M185.334 35.9642V22.0327L183.831 22.9003V36.8317L185.334 35.9642Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M185.356 23.7766L185.334 22.0316L171.863 29.8541V31.5488L185.356 23.7766Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M185.334 22.0316L183.808 21.1506L170.36 28.9866L171.863 29.8541L185.334 22.0316Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M159.848 24.6227V22.8876L170.361 28.9677V30.7352L159.848 24.6227Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M159.848 22.8876L161.277 22.0452L171.793 28.1334L170.402 28.9974L159.848 22.8876Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M158.345 22.0579V8.16241L159.848 9.02998V22.9255L158.345 22.0579Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M161.35 22.0579V8.16241L159.848 9.02998V22.9255L161.35 22.0579Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M170.293 15.1271L170.297 1.19836L171.816 2.07582V16.0073L170.293 15.1271Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M173.318 15.1397V1.20825L171.816 2.07582V16.0073L173.318 15.1397Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M173.318 2.92276V1.2074L159.848 9.0299V10.7246L173.318 2.92276Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M173.318 1.20741L171.792 0.326355L158.345 8.16234L159.848 9.02991L173.318 1.20741Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M171.761 3.80667V2.07153L182.265 8.13912V9.87066L171.761 3.80667Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M171.761 2.07124L173.264 1.20367L183.753 7.26946L182.265 8.21165L171.761 2.07124Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M170.36 29.0056V15.1102L171.864 15.9777V29.8732L170.36 29.0056Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M173.366 29.0056V15.1102L171.864 15.9777V29.8732L173.366 29.0056Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M182.309 22.0749L182.312 8.14618L183.832 9.02364V22.9551L182.309 22.0749Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M185.334 22.0874V8.15601L183.832 9.02357V22.955L185.334 22.0874Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M185.356 9.90018L185.334 8.15515L171.864 15.9777V17.6723L185.356 9.90018Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M185.334 8.15516L183.808 7.27411L170.36 15.1101L171.864 15.9777L185.334 8.15516Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M159.821 10.7597V9.02545L170.333 15.1056V16.8731L159.821 10.7597Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M159.821 9.02544L161.25 8.18304L171.766 14.2704L170.376 15.1344L159.821 9.02544Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M129.406 54.3682L129.41 52.6591L130.913 53.5267L130.908 55.2358L129.406 54.3682Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M141.414 61.3276L141.419 59.6185L142.922 60.4861L142.916 62.1952L141.414 61.3276Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M159.871 22.9372L158.346 22.0571L129.41 52.6548L130.912 53.5224L159.871 22.9372Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M159.837 24.664V22.9486L130.905 53.5356V55.2302L159.837 24.664Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M150.04 44.1416V42.4073L160.595 48.5163L159.296 49.1987L150.04 44.1416Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M150.04 42.4073L151.47 41.5649L161.986 47.6523L160.595 48.5163L150.04 42.4073Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M138.987 50.5393V48.8042L149.541 54.914L148.544 55.9066L138.987 50.5393Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M138.987 48.8042L140.416 47.9618L150.932 54.0501L149.541 54.914L138.987 48.8042Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M130.895 55.2061V53.471L141.448 59.5808L141.414 61.3277L130.895 55.2061Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M130.895 53.471L132.323 52.6295L142.839 58.7169L141.448 59.5809L130.895 53.471Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M171.893 29.91L170.368 29.0298L141.432 59.6276L142.934 60.4952L171.893 29.91Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M171.858 31.637V29.9216L142.927 60.5086V62.2033L171.858 31.637Z",
    fill: "#747773"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mast1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M270.657 185.82L290.921 197.52L311.185 185.82L290.921 174.12L270.657 185.82Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.219 128.936L344.733 136.64L334.733 137.08H325.999L332.548 144.013L279.593 173.848L280.06 188.232L292.177 195.875L349.654 162.981L356.473 170.731L363.025 156.803L364.1 154.713L370.914 150.813L370.469 136.357L358.219 128.936ZM361.254 153.029L367.045 149.719L360.268 145.354L360.288 145.843L364.51 148.341L360.478 150.591L360.559 152.618L361.254 153.029ZM337.868 146.484L334.733 144.899L330.556 147.867L333.701 149.874L337.868 146.484ZM331.221 151.257L329.387 150.076L329.568 158.324L335.691 154.72L330.51 151.654L331.221 151.257ZM340.098 157.327L340.247 165.098L346.855 161.325L340.098 157.327ZM349.743 139.604L355.788 143.18L356.473 142.789L349.696 138.423L349.743 139.604ZM297.68 189.461L297.357 181.406L304.134 185.772L297.68 189.461ZM307.294 175.788L307.617 183.843L314.071 180.154L307.294 175.788ZM304.281 162.979L304.638 171.032L297.843 166.696L304.281 162.979ZM327.282 158.101L326.924 150.049L320.486 153.765L327.282 158.101ZM357.536 140.578L357.179 132.526L350.741 136.242L357.536 140.578ZM294.368 168.64L294.726 176.692L287.93 172.356L294.368 168.64ZM315.235 177.932L314.878 169.88L308.24 173.747L315.235 177.932ZM327.465 162.615L327.665 170.731L320.827 166.482L327.465 162.615ZM337.868 164.918L337.668 156.803L331.03 160.67L337.868 164.918ZM305.063 175.501L305.421 183.554L298.509 179.231L305.063 175.501ZM329.81 162.799L330.133 170.854L336.587 167.165L329.81 162.799ZM319.222 155.986L319.545 164.041L325.999 160.352L319.222 155.986ZM306.779 163.028L306.961 171.188L313.556 167.393L306.779 163.028ZM297.342 176.692L297.019 168.638L303.796 173.003L297.342 176.692ZM368.182 147.476L361.368 143.22L367.896 139.561L368.182 147.476ZM360.121 140.719L359.745 132.758L366.536 137.08L360.121 140.719ZM317.636 178.11L317.398 168.481L318.496 167.847L326.506 173.01L317.636 178.11ZM317.056 165.495L316.807 155.866L307.943 160.976L315.959 166.13L317.056 165.495Z",
    fill: "url(#paint1_linear_1528_778)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mast_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M277.394 179.175L290.903 171.375L304.413 179.175L290.903 186.974L277.394 179.175Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M277.394 179.175V186.974L290.903 194.774V186.974L277.394 179.175Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M290.903 194.774L304.413 186.974V179.175L290.903 186.974V194.774Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M290.903 160.746V159.01L301.407 165.152V166.81L290.903 160.746Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M290.903 159.01L292.406 158.143L301.407 163.582V165.152L290.903 159.01Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M289.401 172.24V129.341L290.903 130.209V173.107L289.401 172.24Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M292.406 172.24V129.341L290.903 130.209V173.107L292.406 172.24Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M290.903 147.328V145.593L301.407 151.661V153.392L290.903 147.328Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M290.903 145.593L292.406 144.726L301.407 150.165V151.734L290.903 145.593Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M290.903 160.746V159.01L280.399 165.152V166.81L290.903 160.746Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M290.903 159.01L289.401 158.143L280.399 163.582V165.152L290.903 159.01Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M290.903 147.328V145.593L280.399 151.733V153.392L290.903 147.328Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M290.903 145.593L289.401 144.726L280.399 150.165V151.734L290.903 145.593Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M277.394 179.175V136.277L278.896 137.144V180.042L277.394 179.175Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M280.399 179.175V136.277L278.896 137.144V180.042L280.399 179.175Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M289.401 186.106V143.209L290.903 144.077V186.974L289.401 186.106Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M292.406 186.106L292.387 141.479L290.885 142.347L290.903 186.974L292.406 186.106Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M301.407 179.175V136.277L302.91 137.144V180.042L301.407 179.175Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M304.413 179.175L304.392 134.582L302.889 135.449L302.91 180.042L304.413 179.175Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M290.903 116.341V114.607L301.407 120.675V122.406L290.903 116.341Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M290.903 114.607L292.406 113.74L301.407 119.178V120.747L290.903 114.607Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M290.903 130.274V128.539L301.407 134.607V136.339L290.903 130.274Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M290.903 128.539L292.406 127.672L301.407 133.111V134.681L290.903 128.539Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M278.896 167.681V165.946L289.401 172.087V173.746L278.896 167.681Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M278.896 165.946L280.399 165.078L289.401 170.517V172.087L278.896 165.946Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M278.896 154.263V152.528L289.401 158.67V160.328L278.896 154.263Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M278.896 152.528L280.399 151.661L289.401 157.1V158.67L278.896 152.528Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M302.909 167.754V166.019L292.406 172.16V173.818L302.909 167.754Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M302.909 166.019L301.407 165.152L292.406 170.59V172.16L302.909 166.019Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M302.909 154.336V152.601L292.406 158.742V160.401L302.909 154.336Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M302.909 152.601L301.407 151.734L292.406 157.173V158.742L302.909 152.601Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M302.91 137.169L302.888 135.423L290.921 142.347V144.067L302.91 137.169Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M304.412 134.542L302.909 133.675L289.418 141.479L290.921 142.347L304.412 134.542Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M290.903 130.239L290.868 128.488L278.896 135.414L278.896 137.144L290.903 130.239Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M292.387 127.609L290.885 126.741L277.394 134.547L278.896 135.414L292.387 127.609Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M277.402 136.338V120.666L278.904 121.534V137.206L277.402 136.338Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M280.407 134.562V120.666L278.905 121.534V135.429L280.407 134.562Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M289.349 127.631L289.354 113.702L290.873 114.58V128.511L289.349 127.631Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M292.376 127.643V113.712L290.873 114.58V128.511L292.376 127.643Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M292.376 115.427V113.711L278.905 121.534V123.229L292.376 115.427Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M292.376 113.711L290.85 112.831L277.402 120.667L278.904 121.534L292.376 113.711Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M289.418 141.51V127.614L290.92 128.482V142.377L289.418 141.51Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M292.422 141.51V127.614L290.92 128.482V142.377L292.422 141.51Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M301.365 134.579L301.369 120.65L302.889 121.528V135.459L301.365 134.579Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M304.391 134.592V120.66L302.889 121.528V135.459L304.391 134.592Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M304.413 122.404L304.391 120.659L290.92 128.482V130.177L304.413 122.404Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M304.391 120.658L302.865 119.778L289.418 127.614L290.92 128.482L304.391 120.658Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M278.896 137.21V135.475L289.401 141.616V143.275L278.896 137.21Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M278.896 135.475L280.399 134.607L289.401 140.046V141.616L278.896 135.475Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M278.896 123.277V121.542L289.401 127.683V129.341L278.896 123.277Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M278.896 121.542L280.399 120.675L289.401 126.114V127.683L278.896 121.542Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M277.402 120.66V106.765L278.904 107.632V121.528L277.402 120.66Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M280.407 120.66V106.765L278.905 107.632V121.528L280.407 120.66Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M289.349 113.73L289.354 99.7999L290.873 100.678V114.609L289.349 113.73Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M292.376 113.741V99.8108L290.873 100.678V114.609L292.376 113.741Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M320.07 85.3607V83.6453L249.904 124.432V126.127L320.07 85.3607Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M292.376 99.809L290.85 98.9289L277.402 106.765L278.904 107.632L292.376 99.809Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M320.077 83.6282L318.552 82.748L248.408 123.551L249.911 124.418L320.077 83.6282Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M290.873 102.413V100.678L301.377 106.746V108.478L290.873 102.413Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M290.873 100.678L292.376 99.8108L302.866 105.877L301.377 106.82L290.873 100.678Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M320.177 85.2778L320.155 83.5319L292.314 85.9449V87.6395L320.177 85.2778Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M320.154 83.5302L318.437 82.7669L290.811 85.0792L292.314 85.9459L320.154 83.5302Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M278.905 109.368V107.632L289.358 113.684L287.983 114.48L278.905 109.368Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M278.905 107.632L280.334 106.79L290.85 112.878L289.459 113.742L278.905 107.632Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M277.343 106.831V92.9351L278.845 93.8026V107.698L277.343 106.831Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M280.348 106.831V92.9351L278.845 93.8026V107.698L280.348 106.831Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M289.29 99.8997L289.295 85.971L290.814 86.8485V100.78L289.29 99.8997Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M292.316 99.9123V85.9809L290.814 86.8485V100.78L292.316 99.9123Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M292.316 87.6952V85.9789L278.845 93.8023V95.497L292.316 87.6952Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M292.316 85.9789L290.791 85.0988L277.343 92.9347L278.845 93.8023L292.316 85.9789Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M300.004 97.1693V95.4341L310.558 101.544L309.259 102.225L300.004 97.1693Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M300.004 95.4341L301.432 94.5917L311.948 100.68L310.558 101.544L300.004 95.4341Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M309.773 91.2951V89.5599L320.327 95.6698L319.329 96.6623L309.773 91.2951Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M309.773 89.5599L311.201 88.7175L321.718 94.8058L320.327 95.6698L309.773 89.5599Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M318.652 86.0745V84.3394L329.206 90.4483L329.171 92.196L318.652 86.0745Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M318.652 84.3393L320.08 83.4969L330.597 89.5852L329.206 90.4483L318.652 84.3393Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M289.418 127.608V113.712L290.92 114.58V128.476L289.418 127.608Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M292.422 127.608V113.712L290.92 114.58V128.476L292.422 127.608Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M301.365 120.677L301.369 106.748L302.889 107.626V121.556L301.365 120.677Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M304.391 120.69V106.759L302.889 107.626V121.557L304.391 120.69Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M332.108 92.3379L332.086 90.5928L261.92 131.379V133.074L332.108 92.3379Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M332.085 90.5903L330.368 89.827L260.416 130.513L261.918 131.38L332.085 90.5903Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M332.108 92.3379L332.086 90.5928L304.246 93.0058V94.7005L332.108 92.3379Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M332.085 90.5903L330.597 89.5852L302.742 92.1394L304.244 93.0069L332.085 90.5903Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M290.873 88.7022V86.9671L301.377 93.0347V94.7662L290.873 88.7022Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M290.873 86.9672L292.376 86.0997L302.866 92.1655L301.377 93.1076L290.873 86.9672Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M289.358 113.778V99.8826L290.861 100.75V114.646L289.358 113.778Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M292.364 113.778V99.8826L290.861 100.75V114.646L292.364 113.778Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M301.306 106.848L301.31 92.9188L302.83 93.7963V107.728L301.306 106.848Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M304.332 106.86V92.9286L302.829 93.7962V107.728L304.332 106.86Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M304.353 94.6726L304.332 92.9276L290.861 100.75V102.445L304.353 94.6726Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M304.332 92.9276L302.806 92.0466L289.358 99.8826L290.861 100.75L304.332 92.9276Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M278.846 95.5187V93.7836L289.359 99.8637V101.631L278.846 95.5187Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M278.846 93.7836L280.275 92.9412L290.791 99.0294L289.401 99.8934L278.846 93.7836Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M277.344 92.9539V79.0584L278.846 79.926V93.8215L277.344 92.9539Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M280.348 92.9539V79.0584L278.846 79.926V93.8215L280.348 92.9539Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M289.291 86.0231L289.296 72.0944L290.815 72.9718V86.9033L289.291 86.0231Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M292.317 86.0357V72.1042L290.815 72.9718V86.9033L292.317 86.0357Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M292.317 73.8188V72.1034L278.846 79.9259V81.6206L292.317 73.8188Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M292.317 72.1034L290.792 71.2224L277.344 79.0583L278.846 79.9259L292.317 72.1034Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M290.759 74.7024V72.9673L301.264 79.0349V80.7664L290.759 74.7024Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M290.759 72.9672L292.262 72.0997L302.752 78.1655L301.264 79.1076L290.759 72.9672Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M289.359 99.9016V86.0062L290.862 86.8737V100.769L289.359 99.9016Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M292.364 99.9016V86.0062L290.862 86.8737V100.769L292.364 99.9016Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M301.307 92.9709L301.311 79.0422L302.831 79.9196V93.8511L301.307 92.9709Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M304.333 92.9834V79.052L302.83 79.9196V93.851L304.333 92.9834Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M304.354 80.7962L304.333 79.0511L290.862 86.8736V88.5683L304.354 80.7962Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M304.333 79.0512L302.807 78.1701L289.359 86.0061L290.862 86.8737L304.333 79.0512Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M278.819 81.6557V79.9214L289.332 86.0016V87.7691L278.819 81.6557Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M278.819 79.9214L280.248 79.079L290.764 85.1664L289.374 86.0304L278.819 79.9214Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M248.404 125.264L248.409 123.555L249.911 124.423L249.907 126.132L248.404 125.264Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M260.413 132.224L260.418 130.515L261.92 131.382L261.915 133.091L260.413 132.224Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M278.87 93.833L277.345 92.9528L248.408 123.551L249.911 124.418L278.87 93.833Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M278.835 95.56V93.8446L249.904 124.432V126.126L278.835 95.56Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M269.039 115.038V113.303L279.593 119.412L278.294 120.095L269.039 115.038Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M269.039 113.303L270.468 112.461L280.984 118.548L279.593 119.412L269.039 113.303Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M257.986 121.435V119.7L268.54 125.81L267.541 126.803L257.986 121.435Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M257.986 119.7L259.414 118.858L269.931 124.946L268.54 125.81L257.986 119.7Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M249.893 126.102V124.367L260.447 130.477L260.413 132.224L249.893 126.102Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M249.893 124.367L251.322 123.525L261.838 129.613L260.447 130.477L249.893 124.367Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M290.892 100.806L289.367 99.9258L260.43 130.524L261.933 131.391L290.892 100.806Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M290.857 102.533V100.817L261.926 131.405V133.099L290.857 102.533Z",
    fill: "#747773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nadel5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70_5",
    d: "M189.787 138.816C192.09 143.874 189.668 148.738 179.315 153.452C168.962 158.166 152.424 164.359 150.12 159.301C147.817 154.242 162.119 140.378 172.472 135.664C182.825 130.95 187.484 133.757 189.787 138.816Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_5",
    d: "M151.379 106.155L156.005 106.155L158.71 109.931H149.213L151.379 106.155Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.393 161.153C155.339 161.153 167.623 130.632 167.623 121.922C167.623 113.211 160.562 106.15 151.851 106.15C143.14 106.15 136.079 113.211 136.079 121.922C136.079 130.632 149.446 161.153 152.393 161.153ZM153.603 126.364C156.953 126.364 159.669 123.648 159.669 120.298C159.669 116.948 156.953 114.232 153.603 114.232C150.253 114.232 147.537 116.948 147.537 120.298C147.537 123.648 150.253 126.364 153.603 126.364Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.443 161.196C155.389 161.196 171.602 130.632 171.602 121.922C171.602 113.211 164.541 106.15 155.83 106.15C147.12 106.15 140.058 113.211 140.058 121.922C140.058 130.632 149.496 161.196 152.443 161.196ZM155.83 127.121C159.181 127.121 161.897 124.405 161.897 121.055C161.897 117.705 159.181 114.989 155.83 114.989C152.48 114.989 149.764 117.705 149.764 121.055C149.764 124.405 152.48 127.121 155.83 127.121Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nadel6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 70_6",
    d: "M160.07 88.7714C162.374 93.83 159.952 98.6939 149.599 103.408C139.246 108.122 122.707 114.315 120.404 109.257C118.101 104.198 132.403 90.3338 142.756 85.62C153.109 80.9061 157.767 83.7129 160.07 88.7714Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 549_6",
    d: "M121.663 56.1112L126.289 56.1111L128.994 59.8864H119.497L121.663 56.1112Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.676 111.109C125.623 111.109 137.907 80.588 137.907 71.8774C137.907 63.1667 130.845 56.1053 122.135 56.1053C113.424 56.1053 106.363 63.1667 106.363 71.8774C106.363 80.588 119.73 111.109 122.676 111.109ZM123.887 76.3201C127.237 76.3201 129.953 73.6041 129.953 70.2539C129.953 66.9036 127.237 64.1877 123.887 64.1877C120.537 64.1877 117.821 66.9036 117.821 70.2539C117.821 73.6041 120.537 76.3201 123.887 76.3201Z",
    fill: "#C3337F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.726 111.152C125.673 111.152 141.886 80.5881 141.886 71.8775C141.886 63.1668 134.825 56.1055 126.114 56.1055C117.403 56.1055 110.342 63.1668 110.342 71.8775C110.342 80.5881 119.78 111.152 122.726 111.152ZM126.114 77.0769C129.464 77.0769 132.18 74.361 132.18 71.0107C132.18 67.6605 129.464 64.9446 126.114 64.9446C122.764 64.9446 120.048 67.6605 120.048 71.0107C120.048 74.361 122.764 77.0769 126.114 77.0769Z",
    fill: "#B4005F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1528_778",
    x1: 176.161,
    y1: 113.433,
    x2: 270.92,
    y2: 52.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1528_778",
    x1: 295.447,
    y1: 190.528,
    x2: 434.561,
    y2: 111.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetzanschlussmonitor);
export default __webpack_public_path__ + "static/media/Netzanschlussmonitor.c06ebeb43e2247fae3c918348bb39178.svg";
export { ForwardRef as ReactComponent };